import React from 'react';

import { Card } from '@ergeon/core-components';

/**
 * Skeleton placeholder for OrderCard during loading state.
 * Shows animated pulse effect similar to Pipedrive.
 */
const OrderCardSkeleton: React.FC = () => {
  return (
    <Card className="flex flex-col gap-2 p-2" zIndex="2">
      {/* Header row skeleton */}
      <div className="flex justify-between items-start gap-2">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse flex-1" />
        <div className="h-4 w-12 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
      </div>

      {/* Metadata block skeleton */}
      <div className="flex flex-col gap-1">
        <div className="h-3 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
        <div className="h-3 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
        <div className="h-3 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
      </div>
    </Card>
  );
};

export default OrderCardSkeleton;
